import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ModuloRiordino } from 'src/app/models/modulo-riordino';
@Injectable({
  providedIn: 'root',
})
export class ModuloRiordinoService {
  private http = inject(HttpClient);
  mrUrl = environment.ildatoArticoliDpi + 'api/moduloriordino';

  list(): Observable<ModuloRiordino[]> {
    return this.http.get<ModuloRiordino[]>(this.mrUrl);
  }

  get(idTipologia: number): Observable<ModuloRiordino> {
    return this.http.get<ModuloRiordino>(this.mrUrl + '/' + idTipologia);
  }

  insert(values: ModuloRiordino): Observable<ModuloRiordino> {
    return this.http.post<ModuloRiordino>(this.mrUrl, values);
  }

  remove(idTipologia: number): Observable<ModuloRiordino> {
    return this.http.delete<ModuloRiordino>(this.mrUrl + '/' + idTipologia);
  }

  update(key: number, values: ModuloRiordino): Observable<ModuloRiordino> {
    return this.http.put<ModuloRiordino>(this.mrUrl + '/' + key, values);
  }
}
